export default __webpack_public_path__ + "static/media/ai-logo.0d5442bf.svg";